import { Injectable, Inject } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot } from "@angular/router";
import { SiteModel } from "../models/site.model";
import { SiteService } from "../services/site.service";

@Injectable()
export class SitesResolver implements Resolve<SiteModel[]> {

    constructor(
        private siteService: SiteService
    ) { }

    resolve(route: ActivatedRouteSnapshot) {
        return this.siteService.all();
    }
}
